import _extends from "@babel/runtime/helpers/extends";
import { Button, createStyles, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles, TextField, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useLocalization } from "../../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    ListIcon: {
      paddingLeft: '0px',
      height: '32px',
      '& .MuiIconButton-label': {
        flexDirection: 'column',
        height: 'inherit',
        justifyContent: 'center',
        '& .icon-container': {
          '&:first-of-type': {
            marginBottom: '-14px'
          },
          height: '23px',
          position: 'relative',
          '& .down-arrow': {
            top: '0',
            right: '0',
            position: 'absolute',
            marginTop: '0px',
            marginRight: '-13px'
          }
        }
      }
    },
    dialog: {
      border: 'none !important',
      borderRadius: 12,
      boxShadow: '0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      padding: '1.6rem',
      maxWidth: '600px',
      width: '100%',
      '&::backdrop': {
        backgroundColor: 'rgba(255, 255, 255, .75)'
      },
      '& .MuiDialogContent-root': {
        padding: 0
      },
      '& .MuiDialogTitle-root': {
        paddingLeft: 0
      },
      '& .tox-icon': {
        position: 'absolute',
        top: '0',
        right: '0',
        marginRight: '25px',
        marginTop: '20px',
        cursor: 'pointer',
        padding: '10px'
      }
    },
    accordion: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '15px',
      border: '2px solid',
      borderColor: '#006ce7',
      position: 'relative',
      padding: '10px',
      borderRadius: '10px',
      '& .panel-close-button': {
        position: 'absolute',
        right: '0',
        top: '0'
      }
    },
    accordionContainer: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '20px'
    },
    actionPanel: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between'
    },
    modal: {
      '& .MuiDialogContent-root': {
        padding: '8px 15px'
      }
    }
  });
});
const Panel = ({
  title,
  body
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "panel panel-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "panel-title"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#collapse1716279617835-0",
    className: "collapsed"
  }, /*#__PURE__*/React.createElement("i", {
    className: "svg"
  }), title))), /*#__PURE__*/React.createElement("div", {
    className: "panel-collapse collapse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, body)));
};
const initialAccordion = {
  title: '',
  body: ''
};
export const AccordionPluginControl = ({
  editor,
  buttonProps,
  closeDialog
}) => {
  const [accordions, setAccordions] = useState([initialAccordion]);
  const form = useRef(null);
  const classes = useStyles();
  const localization = useLocalization();
  const handleClose = useCallback(() => {
    setAccordions([initialAccordion]);
    closeDialog();
  }, [closeDialog]);
  const handleSubmit = () => {
    var _form$current;
    if (accordions.length === 0) {
      handleClose();
      return;
    }
    if (!((_form$current = form.current) !== null && _form$current !== void 0 && _form$current.reportValidity())) {
      return;
    }
    const panelGroup = renderToString( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "panel-group"
    }, accordions.map((item, index) => {
      return /*#__PURE__*/React.createElement(Panel, {
        key: index,
        title: item.title,
        body: item.body
      });
    })), /*#__PURE__*/React.createElement("p", null)));
    editor.execCommand('mceInsertContent', false, panelGroup);
    handleClose();
  };
  const handleClosePanel = index => {
    setAccordions(prev => {
      return prev.filter((_, i) => i !== index);
    });
  };
  const dialogRef = useRef(null);
  useEffect(() => {
    var _dialogRef$current;
    (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.showModal();
    return () => {
      var _dialogRef$current2;
      // eslint-disable-next-line react-hooks/exhaustive-deps
      (_dialogRef$current2 = dialogRef.current) === null || _dialogRef$current2 === void 0 ? void 0 : _dialogRef$current2.close();
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("dialog", {
    ref: dialogRef,
    className: classes.dialog
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "form-dialog-title"
  }, localization.accordionControl.title), ' ', /*#__PURE__*/React.createElement("span", {
    className: "tox-icon",
    onClick: () => {
      var _dialogRef$current3;
      (_dialogRef$current3 = dialogRef.current) === null || _dialogRef$current3 === void 0 ? void 0 : _dialogRef$current3.close();
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3 8.2 13.4 12l3.9 3.8a1 1 0 0 1-1.5 1.5L12 13.4l-3.8 3.9a1 1 0 0 1-1.5-1.5l3.9-3.8-3.9-3.8a1 1 0 0 1 1.5-1.5l3.8 3.9 3.8-3.9a1 1 0 0 1 1.5 1.5Z",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", {
    ref: form,
    className: classes.accordionContainer
  }, accordions.map((accordion, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: localization.accordionControl.closePanel
    }, /*#__PURE__*/React.createElement(IconButton, _extends({
      className: "panel-close-button",
      onClick: () => handleClosePanel(index)
    }, buttonProps), /*#__PURE__*/React.createElement(Close, {
      color: "error"
    }))), /*#__PURE__*/React.createElement(TextField, {
      autoFocus: true,
      margin: "dense",
      label: localization.accordionControl.title,
      type: "text",
      required: true,
      fullWidth: true,
      value: accordion.title,
      onChange: e => {
        const newAccordions = [...accordions];
        newAccordions[index] = {
          ...accordions[index],
          title: e.target.value
        };
        setAccordions(newAccordions);
      }
    }), /*#__PURE__*/React.createElement(TextField, {
      multiline: true,
      autoFocus: true,
      margin: "dense",
      label: localization.accordionControl.body,
      type: "text",
      required: true,
      fullWidth: true,
      value: accordion.body,
      onChange: e => {
        const newAccordions = [...accordions];
        newAccordions[index] = {
          ...accordions[index],
          body: e.target.value
        };
        setAccordions(newAccordions);
      }
    }));
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement("div", {
    className: classes.actionPanel
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setAccordions(prev => {
      return [...prev, initialAccordion];
    }),
    title: localization.accordionControl.addPanel
  }, localization.accordionControl.addPanel), /*#__PURE__*/React.createElement("div", {
    className: "close-actions"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose
  }, localization.common.cancel), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      handleSubmit();
    },
    color: "primary"
  }, localization.imageControl.submit))))));
};
//# sourceMappingURL=accordion-plugin.js.map